(function () {

  'use strict';

  angular.module('Setup')
    .controller('SetupController', function (
      $http, $scope, $timeout, $window, deviceDetector, currentTenant, TenantListService,
      EventServiceEvents, RegexModel, UserListService, SUPPORTED_OS,
      ApplicationType, CpuArchitecture, FileType, OperatingSystem, SoftwareService) {

      const detectedOs = deviceDetector.os.substring(0, 3).toUpperCase();
      $scope.isWindowsOs = detectedOs === OperatingSystem.WIN;
      $scope.isMacOs = detectedOs === OperatingSystem.MAC;

      $scope.tenant = angular.copy(currentTenant);
      $scope.suppressDiscoverButton = false;

      $scope.SUPPORTED_OS = SUPPORTED_OS;

      $scope.orderOfBusiness = [];

      $scope.firstWorkstation = null;
      $scope.todoMap = {};

      $scope.me = null;
      $scope.steps = null;

      $scope.setupConcluded = false;

      $scope.password = {
        valid: false,
        length_ok: false,
        has_number: false,
        has_mixedCases: false,
        password: ''
      };

      $scope.isDestroyed = false;

      $scope.helpCaption = 'HelpSetupAssistant';

      (function () {
        setListeners();

        $scope.todoMap = TenantListService.currentTenant.info.todoMap;
        setOrderOfBusiness();

        if ($scope.todoMap.OPEN_DASHBOARD) {
          TenantListService.currentTenant.removeToDoItem($scope.todoMap.OPEN_DASHBOARD);
        }
        if ($scope.todoMap.SHOW_INTRODUCTION) {
          TenantListService.currentTenant.removeToDoItem($scope.todoMap.SHOW_INTRODUCTION);
        }

        getMeUser(true);
        getDownloadUrls();
      })();

      function setOrderOfBusiness() {
        if ($scope.todoMap.DOWNLOAD_CLIENT) {
          $scope.orderOfBusiness = ['DOWNLOAD_CLIENT', 'AWAIT_WORKSTATION', 'AWAIT_INITIAL_DISCOVERY'];
        } else if ($scope.todoMap.AWAIT_WORKSTATION) {
          $scope.orderOfBusiness = ['AWAIT_WORKSTATION', 'AWAIT_INITIAL_DISCOVERY'];
        } else if ($scope.todoMap.AWAIT_INITIAL_DISCOVERY) {
          $scope.orderOfBusiness = ['AWAIT_INITIAL_DISCOVERY'];
        }
      }

      function watchTheTodos() {
        $scope.$watch(function () {
          return TenantListService.currentTenant.info._embedded.toDos;
        }, function (newValue, oldValue) {
          if (newValue !== oldValue) {
            checkTodoList();
          }
        });
      }

      function checkTodoList() {
        $scope.todoMap = TenantListService.currentTenant.info.todoMap;
        checkForMissingPassword();
        watchTheTodos();
      }

      function getMeUser(initial) {
        UserListService.getCurrentUser()
          .then(function (response) {
            $scope.me = response;
            if (!$scope.todoMap.AWAIT_WORKSTATION) {
              getWorkstation();
            }
            if (initial) {
              $scope.steps = $scope.me.info._embedded.user.missingPassword ? 4 : 3;
            }
            checkTodoList();
          })
          .catch(function () {
          });
      }

      function checkForMissingPassword() {
        if ($scope.me && $scope.me.info._embedded.user.missingPassword) {
          $scope.orderOfBusiness.unshift('ENTER_PASSWORD');
          $scope.todoMap.ENTER_PASSWORD = 'ENTER_PASSWORD';
        }
      }

      $scope.checkPassword = function () {
        const regex = new RegexModel();
        const password = $scope.password.password;
        $scope.password.length_ok = password.length >= 6;
        $scope.password.has_number = regex.hasNumber().test(password);
        $scope.password.has_mixedCases = regex.hasMixedCases().test(password);
        $scope.password.valid = regex.passwordValid().test(password);
      };

      $scope.savePassword = function () {
        const body = {
          newPassword: $scope.password.password
        };
        const url = $scope.me.info._embedded.user._links['px:switchPassword'].href;
        $http.post(url, body)
          .then(function (response) {
            if ($scope.todoMap.ENTER_PASSWORD) {
              delete $scope.todoMap.ENTER_PASSWORD;
              if ($scope.orderOfBusiness[0] === 'ENTER_PASSWORD') {
                $scope.orderOfBusiness.shift();
              }
              $scope.nextOrderOfBusiness('ENTER_PASSWORD');
            }
            getMeUser();
          })
          .catch(function () {
          });
      };

      $scope.initOrderOfBusiness = function () {
        if ($scope.steps > $scope.orderOfBusiness.length) {
          const todoContainer = document.getElementById('TODO_CONTAINER');
          const downloadClientElementHeight = document.getElementById('DOWNLOAD_CLIENT').getBoundingClientRect().height;
          const awaitWorkstationElementHeight = document.getElementById('AWAIT_WORKSTATION').getBoundingClientRect().height;
          switch ($scope.orderOfBusiness[0]) {
            case 'AWAIT_WORKSTATION':
              todoContainer.scrollTo({
                top: todoContainer.scrollTop + downloadClientElementHeight + 36,
                behavior: 'smooth'
              });
              break;
            case 'AWAIT_INITIAL_DISCOVERY':
              todoContainer.scrollTo({
                top: todoContainer.scrollTop + awaitWorkstationElementHeight + downloadClientElementHeight + 36,
                behavior: 'smooth'
              });
              break;
          }
        }
      };

      $scope.nextOrderOfBusiness = function (nextOrderOfBusiness) {
        $timeout(() => {
          const todoContainer = document.getElementById('TODO_CONTAINER');
          const previousElement = document.getElementById(nextOrderOfBusiness);
          todoContainer.scrollTo({
            top: todoContainer.scrollTop + previousElement.getBoundingClientRect().height + 36,
            behavior: 'smooth'
          });
        }, 500);
      };

      $scope.downloadClient = function (downloadUrl) {
        if ($scope.todoMap.DOWNLOAD_CLIENT) {
          TenantListService.currentTenant.removeToDoItem($scope.todoMap.DOWNLOAD_CLIENT)
            .then(function () {
              $window.open(downloadUrl, '_self');
            })
            .catch(function () {
            });
        } else {
          $window.open(downloadUrl, '_self');
        }
        if ($scope.orderOfBusiness[0] === 'DOWNLOAD_CLIENT') {
          $scope.orderOfBusiness.shift();
        }
        $scope.nextOrderOfBusiness('DOWNLOAD_CLIENT');
      };

      function getDownloadUrls() {
        if ($scope.isWindowsOs) {
          getConfiguredSoftwareDownloadUrl(OperatingSystem.WIN, CpuArchitecture.X64, FileType.EXE)
            .then(function (downloadUrl) {
              $scope.windowsX64DownloadUrl = downloadUrl;
            });
          getConfiguredSoftwareDownloadUrl(OperatingSystem.WIN, CpuArchitecture.ARM64, FileType.EXE)
            .then(function (downloadUrl) {
              $scope.windowsArm64DownloadUrl = downloadUrl;
            });
        } else if ($scope.isMacOs) {
          getConfiguredSoftwareDownloadUrl(OperatingSystem.MAC, undefined, FileType.DMG)
            .then(function (downloadUrl) {
              $scope.macDownloadUrl = downloadUrl;
            });
        }
      }

      function getConfiguredSoftwareDownloadUrl(operatingSystem, cpuArchitecture, fileType) {
        const applicationType = ApplicationType.CLIENT;
        return SoftwareService.getConfiguredSoftwareVersion(applicationType, operatingSystem, cpuArchitecture, fileType)
          .then(function (responseData) {
            const softwareVersion = responseData._embedded['px:softwareResources'][0];
            if (softwareVersion.files.length) {
              return SoftwareService.buildDesktopApplicationDownloadUrl(
                applicationType, operatingSystem, cpuArchitecture, fileType, softwareVersion.version);
            } else {
              return null;
            }
          })
          .catch(function () {
            return null;
          });
      }

      $scope.discoverPrinters = function (event, context, menuOption) {
        $scope.suppressDiscoverButton = true;
        $timeout(function  () {
          if (event && context && menuOption) {
            $scope.selectedContextMenuItem = menuOption;
            $scope.contextPosition = { left: event.clientX, top: event.clientY };
            $scope.context = context;
            $scope.context.networkDefinition = {
              networkMethod: 'DISCOVER',
              name: $scope.firstWorkstation.networking.ssid || null,
              workstation: $scope.firstWorkstation
            };
          }
        });
      };

      $scope.closeAllMenues = function () {
        $scope.suppressDiscoverButton = false;
        $scope.selectedContextMenuItem = null;
        $scope.contextPosition = null;
        $scope.context = null;
        $scope.setupConcluded = true;
      };

      $scope.printers = 0;

      $scope.getPrinters = function () {
        const url = $scope.tenant.info._links['px:printers'].href;
        const params = {
          page: 0,
          pageSize: 1,
          sort: 'NAME',
          direction: 'ASC',
          types: 'NETWORK'
        };
        $http.get(url, { params })
          .then(function (printers) {
            if (printers.data._embedded) {
              $scope.printers = printers.data.page.totalElements;
            }
          })
          .catch(function () {
          });
      };

      let getComputerRetry = 0;

      // KEEP GETTING WORKSTATION UNTIL IT IS FLAGGED AS ACTIVE, find a better way to get users computer
      function getWorkstation() {
        const url = $scope.tenant.info._links['px:workstations'].href + '?find';
        const body = {
          page: 0,
          pageSize: 100,
          direction: 'ASC',
          sort: 'NAME',
          embed: ['adapters', 'queues', 'tasks', 'networks'],
          user: $scope.me.info._links.self.href.split('users/')[1]
        };
        $http.post(url, body)
          .then(function (response) {
            if (response.data._embedded) {
              response.data._embedded['px:workstationResources'].forEach((workstation) => {
                if (workstation.active) {
                  $scope.firstWorkstation = workstation;
                } else {
                  getComputerRetry += 1;
                  if (getComputerRetry < 25) {
                    retryGettingComputer();
                  } else {
                    $scope.firstWorkstation = workstation;
                  }
                }
              });
            } else {
              getComputerRetry += 1;
              if (getComputerRetry < 25) {
                retryGettingComputer();
              }
            }
          })
          .catch(function () {
          });
      }

      function retryGettingComputer() {
        if (!$scope.isDestroyed) {
          $timeout(() => {
            getWorkstation();
          }, 1000);
        }
      }

      $scope.$on('$destroy', function () {
        $scope.isDestroyed = true;
      });

      function setListeners() {

        $scope.$on(EventServiceEvents.CHANNELS.ALL_TENANT_ADMINS.EVENTS.TODO_REMOVED, function (event, data) {
          if (data.todo === 'AWAIT_WORKSTATION') {
            if ($scope.orderOfBusiness[0] === 'AWAIT_WORKSTATION') {
              $scope.orderOfBusiness.shift();
              $scope.nextOrderOfBusiness('AWAIT_WORKSTATION');
            }
            getWorkstation();
          }
        });

        $scope.$on(EventServiceEvents.CHANNELS.SPECIFIC_USER.EVENTS.DISCOVERY_REPORT, function (event, data) {
          TenantListService.currentTenant.removeToDoItem($scope.todoMap.AWAIT_INITIAL_DISCOVERY);
        });

        $scope.$on('CHECK_TODO_LIST', function () {
          if ($scope.me) {
            checkTodoList();
          }
        });

      }

    });
})();
